//Regular bricks
export {default as TouchPointSettings} from './Touchpoint/TouchpointBrickSettings';
export {default as JourneySettings} from './Journey/BrickSettingsJourney';
export {default as AudienceFilterSettings} from './AudienceFilter/AudienceFilterBrickSettings';
export {default as AudienceSettings} from './Audience/BrickSettingsAudience';
export {default as GoalSettings} from './Goal/GoalBrickSettings';
export {default as ABTestSettings} from './ABTest'

//Checkpoints
export { default as ConnectionSettings } from './Connection/BrickBasicSettings';
export { default as DedupBaseSettings } from './Connection/BrickDedupBaseSettings';
export { default as DedupTargetSettings } from './Connection/BrickDedupTargetSettings';
export { default as FilterSettings } from './Connection/BrickFilterSettings';
export { default as DelaySettings } from './Connection/BrickDelaySettings';
export { default as FilterExclusionSettings } from './Connection/BrickFilterExclusionSettings';